// config
export const SET_VIEWPORT = 'SET_VIEWPORT';

// content
export const RECEIVE_TEXT_CONTENT = 'RECEIVE_TEXT_CONTENT';

// destination
export const SET_DESTINATION_URGENCY_MESSAGE =
    'SET_DESTINATION_URGENCY_MESSAGE';
export const SET_DESTINATION_INFOGRAPHIC = 'SET_DESTINATION_INFOGRAPHIC';
export const SET_UNIT_REVIEWS = 'SET_UNIT_REVIEWS';
export const SET_DESTINATION_IMAGES = 'SET_DESTINATION_IMAGES';
export const SET_AFFINITIES = 'SET_AFFINITIES';

// listings
export const LOADING_LISTINGS = 'LOADING_LISTINGS';
export const FAILED_LISTINGS = 'FAILED_LISTINGS';
export const SET_LISTINGS = 'SET_LISTINGS';

// destinations listings
export const SET_DESTINATIONS_LISTINGS = 'SET_DESTINATIONS_LISTINGS';

// search
export const RECEIVE_SERP_URL_DOMAIN = 'RECEIVE_SERP_URL_DOMAIN';
export const RECEIVE_REFINEMENTS = 'RECEIVE_REFINEMENTS';
export const RECEIVE_KEYWORDS = 'RECEIVE_KEYWORDS';
export const RECEIVE_ARRIVAL_DATE = 'RECEIVE_ARRIVAL_DATE';
export const RECEIVE_DEPARTURE_DATE = 'RECEIVE_DEPARTURE_DATE';
export const REDIRECT = 'REDIRECT';
export const HIDE_DATES_POPUP = 'HIDE_DATES_POPUP';
export const SHOW_DATES_POPUP = 'SHOW_DATES_POPUP';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const UPDATE_GUESTS = 'UPDATE_GUESTS';

// great places
export const HIDE_GOOGLE_MAP = 'HIDE_MAP';
